import { render, staticRenderFns } from "./addAdminUser.vue?vue&type=template&id=493dcf25&scoped=true&"
import script from "./addAdminUser.vue?vue&type=script&lang=ts&"
export * from "./addAdminUser.vue?vue&type=script&lang=ts&"
import style0 from "./addAdminUser.vue?vue&type=style&index=0&id=493dcf25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493dcf25",
  null
  
)

export default component.exports